import Swiper, { Navigation, Pagination, Autoplay, Controller, Grid } from 'swiper';
import Glightbox from 'glightbox';

export default (() => {
  const sliderGallery = $('.thor-achievements-gallery');

  sliderGallery.each(function () {
    const slider = $(this).find('.swiper');
    const buttonNext = $(this).find('.swiper-button-next')[0];
    const buttonPrev = $(this).find('.swiper-button-prev')[0];
    const pagination = $(this).find('.swiper-pagination')[0];

    new Swiper(slider.get(0), {
      modules: [Autoplay, Navigation, Controller, Pagination, Grid],
      slidesPerView: 2,
      slidesPerGroup: 4,
      spaceBetween: 15,
      grid: {
        fill: 'row',
        rows: 2,
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      pagination: {
        el: pagination,
        type: 'fraction',
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          slidesPerGroup: 6,
          grid: {
            fill: 'row',
            rows: 2,
          },
        },
        1024: {
          slidesPerView: 5,
          slidesPerGroup: 10,
          grid: {
            fill: 'row',
            rows: 2,
          },
        },
      },
      on: {
        init: function () {
          const lightbox = Glightbox({
            selector: '.thor-achievements-gallery a',
            title: false,
            description: false,
            events: {
              open: function () {
                // Disable Swiper drag events when Glightbox is opened
                mySwiper.allowSlideNext = mySwiper.allowSlidePrev = false;
              },
              close: function () {
                // Enable Swiper drag events when Glightbox is closed
                mySwiper.allowSlideNext = mySwiper.allowSlidePrev = true;
              },
            },
          });
        },
      },
    });
  });
})();



// WEBPACK FOOTER //
// ./scripts/gutenberg/blocks/slider-gallery.js